import React from 'react';
import styled from 'styled-components';
import { Header4Text } from 'ui-toolkit';
import { bullet } from '../../../../utilities/order/magicStrings';
import { IPropertyAddress } from '../../../../ui-toolkit/orders/interfaces/IPropertyAddress';

export interface IOrderDetailsItemProps {
  address: IPropertyAddress;
  fileNumber: string;
  transactionCategory: string;
  progressHeading: string;
  progressSubheading: string;
}

const StyledUl = styled.ul`
  margin: 0;
  padding: 0;
`;

const StyledLi = styled.li`
  display: inline;
  ${(props) => props.theme.fonts.mixins.tiny}

  :before {
    content: ' ${bullet} ';
  }

  :first-child:before {
    content: none;
  }
`;

const OrderDetailsItem: React.FC<IOrderDetailsItemProps> = ({
  address,
  fileNumber,
  transactionCategory,
  progressHeading,
  progressSubheading,
}) => (
  <div>
    <Header4Text>
      {address.street_address} {address.city}, {address.state} {address.zip_code}
    </Header4Text>
    <StyledUl>
      <StyledLi>{fileNumber}</StyledLi>
      <StyledLi>{transactionCategory}</StyledLi>
      <StyledLi>{`${progressHeading}: ${progressSubheading}`}</StyledLi>
    </StyledUl>
  </div>
);

export default OrderDetailsItem;
